export const SUPPORTED_LANGUAGES = ["ko", "en"] as const;

export const TRANSLATION_NAMESPACES = [
  "login",
  "branch-management",
  "branches",
  "resource",
  "camera-mapping",
  "analysis-draft",
  "analysis-sketch",
  "space-identify",
  "version",
  "shared",
  // kenny: mash-design-system 네임스페이스
  "translation",
] as const;
